import React from "react";
import { ImageSlider } from "./ImageSlider";

const galleryImages = [
  {
    src: "/galerija1.jpg",
    alt: "Galerija – fotografija 1",
    caption: "Topao enterijer RESTORANA KRČMA sa drvetom i ciglom.",
    objectPosition: "center 72%"
  },
  {
    src: "/galerija2.jpg",
    alt: "Galerija – fotografija 2",
    caption: "Specijaliteti nacionalne kuhinje pripremljeni po domaćim receptima."
  },
  {
    src: "/galerija3.jpg",
    alt: "Galerija – fotografija 3",
    caption: "Banket sala pripremljena za svečane trenutke sa porodicom i prijateljima."
  },
  {
    src: "/galerija4.jpg",
    alt: "Galerija – fotografija 4",
    caption: "Rustične sobe za miran boravak nakon proslave."
  },
  {
    src: "/galerija5.jpg",
    alt: "Galerija – fotografija 5",
    caption: "Pogledajte deo atmosfere iz našeg ambijenta."
  }
];

export function GallerySection() {
  return (
    <section className="section gallery-section">
      <div className="section-inner">
        <header className="section-header">
          <p className="section-eyebrow">Galerija</p>
          <h1 className="section-title">Upoznajte naš ambijent</h1>
          <p className="section-subtitle">
            Pogledajte deo atmosfere iz restorana, banket sale, soba i naših
            događaja. Fotografije su samo mali uvod u ono što vas očekuje uživo.
          </p>
        </header>
      </div>
      <div className="slider-fullbleed">
        <ImageSlider images={galleryImages} auto interval={6500} />
      </div>
    </section>
  );
}
